import { render } from "./PainelCadastroA.vue?vue&type=template&id=1de08ea4&scoped=true"
import script from "./PainelCadastroA.vue?vue&type=script&lang=js"
export * from "./PainelCadastroA.vue?vue&type=script&lang=js"

import "./PainelCadastroA.vue?vue&type=style&index=0&id=1de08ea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de08ea4"]])

export default __exports__